import { __, __r } from 'react-i18n';
import { push } from 'react-router-redux';

import {
  LOGIN_USER,
  LOGOUT_USER,
  RESET_CART,
  UPDATE_USER_DATA,
  USER_COOKIE,
} from './constants';
import * as cookies from 'react-cookies';
import * as moment from 'moment';
import { cookiesExpiresDate } from '../../utilities';

const loginUserAction = (user, token) => ({
  type: LOGIN_USER,
  payload: {
    user,
    token,
  },
});

const logoutUserAction = () => {
  return {
    type: LOGOUT_USER,
  };
};

const resetCartAction = () => {
  return {
    type: RESET_CART,
  };
};

export const loginUser = (
  accessToken,
  withGroups = false,
  resetCart = null,
) => {
  return async (dispatch, getState, API) => {
    if (!accessToken) {
      return;
    }
    try {
      // call API to get user info
      const {
        token_info: { expires_at_date: expireDate },
        ...user
      } = await API.tokeninfo({
        accessToken,
        withGroups: withGroups ? '1' : '0',
      });

      cookies.remove('cart_id', { path: '/' });
      // dispatch(resetCartAction());

      // check if token is valid ( not expired )
      if (moment() < moment(expireDate)) {
        cookies.save(USER_COOKIE, accessToken, {
          path: '/',
          expires: cookiesExpiresDate(),
        }); // save user's access token to cookies
        API.setToken(accessToken);
        dispatch(loginUserAction(user, accessToken)); // save user to redux
      } else {
        dispatch(logoutUser(false, resetCart));
      }
    } catch (e) {
      dispatch(logoutUser(false, resetCart));
    }
  };
};

export const logoutUser = (
  redirectAfter = true,
  resetCart = null,
  redirectRoute = '',
) => {
  return async (dispatch, getState, API) => {
    cookies.remove(USER_COOKIE, { path: '/' }); // delete user's access token from cookies
    if (getState().auth.user && getState().auth.token) {
      try {
        await API.oauthLogout();
      } catch (e) {
        console.log(e);
      } finally {
        try {
          cookies.remove('cart_id', { path: '/' });
          dispatch(logoutUserAction());
          if (resetCart) {
            resetCart();
          }
          // dispatch(resetCartAction());
          API.setToken('');
        } catch (e) {
          console.log(e);
        }
      }
    }
    if (redirectAfter) {
      dispatch(
        push(
          redirectRoute
            ? redirectRoute
            : __r('routes:prihlasenie', '/prihlasenie'),
        ),
      );
    }
  };
};

export const updateUserData = ({ name, surname, email }) => ({
  type: UPDATE_USER_DATA,
  payload: {
    user: {
      name,
      surname,
      email,
    },
  },
});
